import { ArrowOutward } from '@mui/icons-material';
import { Stack, Typography, useTheme } from '@mui/material';
import Box from '@mui/system/Box';
import React from 'react';

import { MenuItemEnum } from '@/components/layout/sidebar/sideBarMenu/model/SideBarMenuItems.model.tsx';
import { OcdRouterLink } from '@/components/layout/topBar/components/TopBarMenuItem.comp.tsx';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

export const ContactMenuItem: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslationWithPrefix('menu.item');

  const menuItem = MenuItemEnum.CONTACT;

  return (
    <Box
      sx={{
        '&:hover': {
          backgroundColor: theme.colors.bgCard3,
          color: theme.colors.topbarText,
        },
        borderRadius: '16px',
        color: theme.colors.topbarTextMuted,
        cursor: 'pointer',
        transition: 'all 0.2s cubic-bezier(0.4,0,0.2,1)',
      }}
    >
      <OcdRouterLink id={menuItem} route={RouteEnum.CONTACT}>
        <Stack
          direction="row"
          sx={{
            '&:hover .contact-icon': {
              transform: 'rotate(45deg)',
            },
            alignItems: 'center',

            borderRadius: '16px',

            gap: 0.5,
            px: 1.5,
            py: 1,
            transition: 'all 0.2s cubic-bezier(0.4,0,0.2,1)',
          }}
        >
          <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{t(menuItem)}</Typography>
          <ArrowOutward
            className="contact-icon"
            sx={{
              fontSize: '16px',
              mb: 0.25,
              transition: 'transform 0.2s cubic-bezier(0.4,0,0.2,1)',
            }}
          />
        </Stack>
      </OcdRouterLink>
    </Box>
  );
};
